import type from './types';
import {
  getListTransform,
  getDetailTransform,
} from 'helpers/transformResponse';

const INITIAL_STATE = {
  list: {
    content: [],
  },
  detail: {},
  loading: false,
  loadingStations: false,
  stationsList: {
    content: [],
  },
};

/**
 * @param {Object} state - Default application state
 * @param {Object} action - Action from action creator
 * @returns {Object} New state
 */
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case type.CUPOM_OFFERS_FETCHED:
      return {
        ...state,
        list: getListTransform(action.payload) || INITIAL_STATE.list,
        loading: false,
      };
    case type.CUPOM_OFFERS_DETAIL:
      return {
        ...state,
        detail: getDetailTransform(action.payload) || INITIAL_STATE.detail,
        loading: false,
      };
    case type.CUPOM_OFFERS_LOAD:
      return {
        ...state,
        loading: action.payload,
      };
    case type.STATIONS_LOAD:
      return {
        ...state,
        loadingStations: action.payload,
      };
    case type.STATIONS_FETCHED:
      return {
        ...state,
        stationsList: getListTransform(action.payload) || INITIAL_STATE.list,
        loadingStations: false,
      };
    default:
      return state;
  }
};
